import Index from "../../pages/sakura/sanliouLinkage/index";
import PC from "../../pages/sakura/sanliouLinkage/pc";

const base = "sanliouLinkage";

const routes = [
  {
    path: `/${base}/index`,
    name: `${base}-index`,
    component: Index,
  },
  {
    path: `/${base}/enter*`,
    name: `${base}-enter`,
    component: Index,
  },
  {
    path: `/${base}/pc*`,
    name: `${base}-pc`,
    component: PC,
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/sakura/sanliouLinkage.js